import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface SelectGoogleIAPAppsPayload {
  social_account_id: number;
  active_app_ids: string[];
}

interface SelectGoogleIAPAppsResponse {
  message: string;
  active_apps: number;
  deactivated_apps: number;
}

export const useSelectGoogleIAPApps = () => {
  const queryClient = useQueryClient();

  return useMutation<SelectGoogleIAPAppsResponse, Error, SelectGoogleIAPAppsPayload>({
    mutationFn: async (payload) => {
      return httpService.post<SelectGoogleIAPAppsResponse, SelectGoogleIAPAppsPayload>(
        API_CONFIG.path.googleIapSelectApps,
        payload,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
